import { useRecoilValue } from 'recoil';
import { reportHistoricState } from '../../../storage/reports';
import { RouteReportTable } from './RouteReportTable';

type Props = {
  assetId: string;
};

export function RouteReportTableFromAsset({ assetId }: Props) {
  const states = useRecoilValue(reportHistoricState(assetId))?.states;

  return <RouteReportTable states={states} />;
}
